"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UIElementsForm = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const rebass_1 = require("rebass");
const Tabs_1 = require("../../../../components/Tabs");
const UIOptionsActionColumnsForm_1 = require("./UIOptionsActionColumnsForm");
const UIOptionsSidebarForm_1 = require("./UIOptionsSidebarForm");
const UIOptionsStatusbarForm_1 = require("./UIOptionsStatusbarForm");
const UIElementsForm = (props) => {
    return (React.createElement(rebass_1.Box, { p: 2 },
        React.createElement(Tabs_1.Tabs, null,
            React.createElement(Tabs_1.Tabs.Tab, null, "Tool Panel"),
            React.createElement(Tabs_1.Tabs.Tab, null, "Status Bar"),
            React.createElement(Tabs_1.Tabs.Tab, null, "Action Rows"),
            React.createElement(Tabs_1.Tabs.Content, null,
                React.createElement(UIOptionsSidebarForm_1.UIOptionsSidebarForm, { gridOptions: props.gridOptions, onChange: props.onChangedGridOptions })),
            React.createElement(Tabs_1.Tabs.Content, null,
                React.createElement(UIOptionsStatusbarForm_1.UIOptionsStatusbarForm, { gridOptions: props.gridOptions, onChange: props.onChangedGridOptions })),
            ' ',
            React.createElement(Tabs_1.Tabs.Content, null,
                React.createElement(UIOptionsActionColumnsForm_1.UIOptionsActionColumnsForm, { abOptions: props.adaptableOptions, onChange: props.onChangedAdaptableOptions })))));
};
exports.UIElementsForm = UIElementsForm;
